//export const api_host='http://0.0.0.0:8082'
//export const api_host='http://172.21.4.12:8082'
export const api_host='https://api-ih.atentus.com'
export const api_auth='07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2'
export const token="123456"
//export const groupFalabella="[[57844, 59730, 56706],[56702, 56704, 9090, 56705]]"
//export const groupFalabellaServices='[["atWeb", "atIvr", "atWeb"],["atWeb", "atWeb", "atMeta"]]'
//export const groupFalabellaIndex='["Grupo1","Grupo2"]'
export const groupsFalabella='[{"nombre":"Autenticación Usuario (VU) ", "especial":62820}, {"nombre":"Omnichannel BFL-CL Externo ", "especial":62822}, {"nombre":" Omnichannel BFL-CL Interno", "especial":62844}]'


// WEBPACK FOOTER //
// ./src/common/constants.jsx